jQuery(function($)
{
   $(".mask-cnpq").mask("9.99.99.99-9");
});
jQuery(function($)
{
   $(".mask-telefone").mask("(99) 9999-9999?9");
});

$(document).on("change", ":file", function() {
	const input = $(this).get(0);

	if(!input.attributes.hasOwnProperty('pai') || (input.attributes['pai'].value !== 'inscricao' && input.attributes['pai'].value !== 'avaliacao')){
		const id = input.id,
			arquivo = input.files[0],
			identificador = id.substring(id.lastIndexOf('/') + 1),
			xmlhttp = new XMLHttpRequest(),
			formData = new FormData();
		if (arquivo && (input.name != "lattes"  &&  !input.name.startsWith("pdfAtuacao") && input.name!="projeto" && input.name!="pdf")) {
			if (!identificador.length) {
				showMsg('É necessário preencher os outros campos do formulário antes!', 0);
				input.value = null;
			} else if (arquivo.type != 'application/pdf' && identificador != 'arq' && !id.includes('logo')) {
				showMsg('O arquivo só pode ser do tipo PDF!', 0);
				input.value = null;
			} else if (id.includes('logo') && !arquivo.type.startsWith('image')) {
				showMsg('O arquivo só pode ser do tipo imagem!', 0);
				input.value = null;
			} else if (identificador == 'arq' && arquivo.type != 'application/pdf' && !arquivo.type.startsWith('image')) {
				showMsg('O arquivo só pode ser do tipo PDF ou imagem!', 0);
				input.value = null;
			} else if (arquivo.size > 5 * 1024 * 1024) {
				showMsg('O tamanho máximo permitido do arquivo é de 5 Mb', 0);
				input.value = null;
			} else {
				var spinnerStyle = document.getElementById('spinner').style;
				spinnerStyle.display = null;
				formData.append("arquivo", arquivo);
				formData.append("userId", input.userId? input.userId : 0);
				formData.append("editalId", input.editalId? input.editalId : 0);
				xmlhttp.open('POST', id, true);
				xmlhttp.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
				xmlhttp.send(formData);

				xmlhttp.onreadystatechange = function() {
					if (this.readyState == 4) {
						spinnerStyle.display  = 'none';
						if (this.status != 200) {
							input.value = null;
							if (this.responseText)
								showMsg(this.responseText, this.status);
							else
								showMsg('Erro ' + this.status + ' ao carregar o arquivo!', 0);
						}
						else if (this.responseText)
							showMsg(this.responseText, 200);
					}
					else if (id.startsWith('/editals/pdf/')) {
						var anoSelect = document.getElementById('ano'),
							i = anoSelect.length,
							opcoes = anoSelect.options;

						while (--i >= 0)
							if (opcoes[i].value != identificador)
								opcoes.remove(i);
					}
					else if (id.startsWith('/col-lattes/pdf/') || id.startsWith('/comprovante/pdf/') || id.startsWith('/memorial/pdf/'))
						document.getElementById(id.replace('pdf', 'link-pdf')).innerHTML = 'Ver PDF';
				};

			}
		}
	}
});


mostrarAjuda = function(uri) {
	window.open('https://help-infotic.hom.tic.ufrj.br/ajuda-sistema/PIBIAC/' + uri);
	return false;
}
showMsg= function(msg,httpCode){
	let classes="";
	if( httpCode != 200)
		classes="white text text-darken card-panel red  accent-2";
	M.toast({
		html: msg,
		classes: classes,
	}, 3000);
}

// Slider
M.Slider.init(document.getElementsByClassName("slider")[0], {
	indicators: false,
	height: 400,
	transition: 500,
	interval: 6000
});

confirmarEnvioPrj = function() {
	var resposta = confirm("Atenção, nenhuma ação poderá ser cadastrada ou removida para este edital após o envio em definitivo. Deseja continuar?");
	if (!resposta)
		window.history.back();
	return resposta;
}

imprimirComprovante = function() {
	var mywindow = window.open('', 'PRINT', 'height=400,width=600');
	var titulo = document.getElementsByTagName('h4')[0].innerText;
	var texto = document.getElementsByTagName('p')[0].innerHTML;

    mywindow.document.write('<html><head><title>' + titulo + '</title></head><body><h1>' + titulo + '</h1><br><p>' + texto + '</b></body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10

    mywindow.print();
    mywindow.close();

    return true;
}

imprimirParecer = function() {
	var myWindow = window.open('', 'PRINT', 'height=400,width=600');
	var titulo = document.getElementsByTagName('h5')[0].innerText;
	var texto = document.getElementById('corpo').innerHTML;

    myWindow.document.write('<html><head><title>' + titulo + '</title></head><body>' + texto + '</body>');
	myWindow.document.write("<script src='https://code.jquery.com/jquery-1.10.1.min.js'></script>");
    myWindow.document.write("<script>$(window).load(function(){ print(); close(); });</script></html>");
    myWindow.document.close();
    myWindow.focus();

    return true;
}

salvar = function(id, valor) {
	var xmlhttp = new XMLHttpRequest();

	xmlhttp.open('GET', id + valor, true);
	xmlhttp.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
	xmlhttp.send();
	xmlhttp.onreadystatechange = function() {
		if (this.readyState == 4) {
			if (this.responseText)
				showMsg(this.responseText, this.status);
			else
				showMsg('Erro ' + this.status + ' durante a operação!', 0);

			if (!id.startsWith('/avaliacoes/'))
				location.reload();
		}
	};
}

confirmarImpedimento = function() {
	return confirm("Tem certeza de que não pode avaliar a pertinência da ação? Neste caso, a ação não avaliada será redistribuída a outro membro do comitê.");}

confirmarInvalidar = function() {
	return confirm('Tem certeza de que deseja invalidar a avaliação? Essa ação não poderá ser desfeita!');
}

confirmarAdicionar = function() {
	return confirm('Tem certeza de que deseja adicionar uma avaliação? Essa ação não poderá ser desfeita!');
}

confirmarAtribuir = function() {
	var nome = document.getElementById('name').value,
	    cpf = document.getElementById('cpf').value;
	return confirm('Tem certeza de que deseja atribuir a bolsa ao aluno ' + nome + ' de CPF ' + cpf + '? Essa ação não poderá ser desfeita!');
}

confirmarExclusao = function() {
	return confirm("Tem certeza que deseja excluir? Esta operação não pode ser desfeita!");
}

confirmarRemover = function() {
	return confirm('Tem certeza de que deseja remover a bolsa do aluno? Essa ação não poderá ser desfeita!');
}

confirmarRemProj = function() {
	return confirm('Tem certeza de que deseja remover a ação da inscrição? Essa ação não poderá ser desfeita!');
}

verificarResposta = function() {
	if ($('#deferido').val() == 'true' && $('#pertinente').val() == 'false') {
		showMsg('Uma ação cujo recurso foi deferido percisa ser pertinente', 0);
		return false;
	}
	return true;
}

rodarSpinner = function() {
	document.getElementById('spinner').style.display = null;
}

